<section class="page">

  <header class="page-header">
    <div>
      <span class="eyebrow">Gestão do cardápio</span>

      <h1>Produtos e categorias</h1>

      <p>
        Organize as categorias, cadastre produtos e mantenha
        o cardápio atualizado.
      </p>
    </div>
  </header>

  <div
    class="message error-message"
    *ngIf="error">

    {{ error }}
  </div>

  <div
    class="message success-message"
    *ngIf="success">

    {{ success }}
  </div>

  <!-- Seleção do restaurante -->

  <section class="restaurant-selector">
    <div class="selector-content">
      <div>
        <span class="section-label">Restaurante selecionado</span>

        <h2>
          {{
            restaurants.length
              ? 'Escolha onde deseja gerenciar o cardápio'
              : 'Nenhum restaurante encontrado'
          }}
        </h2>
      </div>

      <div class="restaurant-field">
        <label for="restaurant">
          Restaurante
        </label>

        <select
          id="restaurant"
          [(ngModel)]="restaurantId"
          (change)="onRestaurantChange()">

          <option value="">
            Selecione um restaurante
          </option>

          <option
            *ngFor="let restaurant of restaurants"
            [value]="restaurant.id">

            {{ restaurant.name }}
          </option>
        </select>
      </div>
    </div>
  </section>

  <div
    class="content-grid"
    *ngIf="restaurantId">

    <!-- Categoria -->

    <section class="card category-card">
      <div class="card-header">
        <div>
          <span class="section-label">Organização</span>
          <h2>Nova categoria</h2>
          <p>
            Crie grupos como pizzas, bebidas, sobremesas ou combos.
          </p>
        </div>

        <div class="header-icon">
          🗂️
        </div>
      </div>

      <div class="category-form">
        <div class="field">
          <label>Nome da categoria</label>

          <input
            [(ngModel)]="newCategory"
            placeholder="Ex: Pizzas"
            (keyup.enter)="createCategory()">
        </div>







<div class="field full-field">

  <label>
    Imagem da categoria
  </label>

  <label class="upload-area">

    <input
      type="file"
      accept="image/*"
      hidden
      (change)="onCategoryImageSelected($event)">

    <div
      class="upload-placeholder"
      *ngIf="!categoryImagePreview">

      <span class="upload-icon">
        🖼️
      </span>

      <strong>
        Escolher imagem
      </strong>

      <small>
        Essa imagem aparecerá no
        cardápio público
      </small>

    </div>

    <img
      class="selected-image category-selected-image"
      *ngIf="categoryImagePreview"
      [src]="categoryImagePreview"
      alt="Pré-visualização da categoria">

  </label>

  <div
    class="preview-actions"
    *ngIf="categoryImagePreview">

    <span>
      Imagem selecionada
    </span>

    <button
      type="button"
      class="remove-image-button"
      (click)="removeSelectedCategoryImage()">

      Remover imagem

    </button>

  </div>

</div>




        <button
          type="button"
          class="primary-button category-button"
          [disabled]="savingCategory"
          (click)="createCategory()">

          {{
            savingCategory
              ? 'Adicionando...'
              : 'Adicionar categoria'
          }}
        </button>
      </div>

      <!-- <div class="category-list">
        <span
          class="category-chip"
          *ngFor="let category of categories">

          {{ category.name }}
        </span>

        <span
          class="category-empty"
          *ngIf="!categories.length">

          Nenhuma categoria cadastrada.
        </span>
      </div> -->



<div
  class="category-management-list"
  *ngIf="categories.length">

  <article
    class="category-management-item"
    *ngFor="let category of categories"
    [class.category-inactive]="!category.isActive">

    <!-- FOTO -->

    <div class="category-management-image">

      <img
        *ngIf="category.imageUrl"
        [src]="getImageUrl(category.imageUrl)"
        [alt]="category.name">

      <div
        class="category-management-no-image"
        *ngIf="!category.imageUrl">

        <span>🖼️</span>
        <small>Sem foto</small>

      </div>

    </div>

    <!-- INFORMAÇÕES -->

    <div class="category-management-info">

      <div class="category-title-row">

        <strong>
          {{ category.name }}
        </strong>

        <span
          class="category-status"
          [class.category-status-inactive]="!category.isActive">

          {{
            category.isActive
              ? 'Ativa'
              : 'Inativa'
          }}

        </span>

      </div>

      <span class="category-product-count">

        {{
          category._count?.products ??
          category.products?.length ??
          0
        }}

        {{
          (
            category._count?.products ??
            category.products?.length ??
            0
          ) === 1
            ? 'produto'
            : 'produtos'
        }}

      </span>

    </div>

    <!-- AÇÕES -->

    <div class="category-management-actions">

      <!-- TROCAR FOTO -->

      <label
        class="category-action-button image-action">

        <span>📷</span>

        {{
          changingImageCategoryId === category.id
            ? 'Enviando...'
            : category.imageUrl
              ? 'Trocar foto'
              : 'Adicionar foto'
        }}

        <input
          type="file"
          accept="image/*"
          hidden
          [disabled]="
            changingImageCategoryId === category.id
          "
          (change)="
            changeCategoryImage(
              $event,
              category
            )
          ">

      </label>

      <!-- ATIVAR / INATIVAR -->

      <button
        type="button"
        class="category-action-button status-action"
        [class.activate-category]="!category.isActive"
        [disabled]="
          changingStatusCategoryId === category.id
        "
        (click)="toggleCategory(category)">

        <span>
          {{
            category.isActive
              ? '⏸'
              : '▶'
          }}
        </span>

        {{
          changingStatusCategoryId === category.id
            ? 'Alterando...'
            : category.isActive
              ? 'Inativar'
              : 'Ativar'
        }}

      </button>

      <!-- EXCLUIR -->

      <button
        type="button"
        class="category-action-button delete-category"
        [disabled]="
          deletingCategoryId === category.id ||
          (
            category._count?.products ??
            category.products?.length ??
            0
          ) > 0
        "
        [title]="
          (
            category._count?.products ??
            category.products?.length ??
            0
          ) > 0
            ? 'Remova ou mova os produtos antes de excluir esta categoria.'
            : 'Excluir categoria'
        "
        (click)="deleteCategory(category)">

        <span>🗑️</span>

        {{
          deletingCategoryId === category.id
            ? 'Excluindo...'
            : 'Excluir'
        }}

      </button>

    </div>

  </article>

</div>

<div
  class="category-empty-state"
  *ngIf="!categories.length">

  <span>🗂️</span>

  <strong>
    Nenhuma categoria cadastrada
  </strong>

  <small>
    Crie sua primeira categoria acima.
  </small>

</div>
    </section>

    <!-- Produto -->

    <section class="card product-form-card">
      <div class="card-header">
        <div>
          <span class="section-label">
            {{ editingProductId ? 'Edição do produto' : 'Cardápio' }}
          </span>

          <h2>
            {{
              editingProductId
                ? 'Editar produto'
                : 'Novo produto'
            }}
          </h2>

          <p>
            {{
              editingProductId
                ? 'Altere as informações abaixo e salve as mudanças.'
                : 'Preencha as informações que serão exibidas ao cliente.'
            }}
          </p>
        </div>

        <div class="header-icon">
          🍔
        </div>
      </div>

      <div class="product-form-grid">

        <div class="field">
          <label>Categoria *</label>

          <select [(ngModel)]="form.categoryId">
            <option value="">
              Selecione uma categoria
            </option>

            <option
              *ngFor="let category of categories"
              [value]="category.id">

              {{ category.name }}
            </option>
          </select>
        </div>

        <div class="field">
          <label>Nome do produto *</label>

          <input
            [(ngModel)]="form.name"
            placeholder="Ex: Pizza Calabresa">
        </div>

        <div class="field full-field">
          <label>Descrição</label>

          <textarea
            [(ngModel)]="form.description"
            rows="4"
            maxlength="500"
            placeholder="Descreva ingredientes, tamanho e outras informações">
          </textarea>
        </div>

        <div class="field">
          <label>Preço *</label>

          <div class="money-field">
            <span>R$</span>

            <input
              [(ngModel)]="form.price"
              type="number"
              min="0"
              step="0.01"
              placeholder="0,00">
          </div>
        </div>

        <label class="active-control">
          <input
            type="checkbox"
            [(ngModel)]="form.isActive">

          <span class="switch">
            <span></span>
          </span>

          <span class="active-control-text">
            <strong>Produto ativo</strong>
            <small>Exibir no cardápio público</small>
          </span>
        </label>

        <div
          class="field full-field"
          *ngIf="!editingProductId">

          <label>Imagem do produto</label>

          <label class="upload-area">
            <input
              type="file"
              accept="image/*"
              hidden
              (change)="onImageSelected($event)">

            <div
              class="upload-placeholder"
              *ngIf="!imagePreview">

              <span class="upload-icon">📷</span>
              <strong>Escolher imagem</strong>
              <small>
                Clique para selecionar uma imagem do produto
              </small>
            </div>

            <img
              class="selected-image"
              *ngIf="imagePreview"
              [src]="imagePreview"
              alt="Pré-visualização do produto">
          </label>

          <div
            class="preview-actions"
            *ngIf="imagePreview">

            <span>
              Imagem selecionada
            </span>

            <button
              type="button"
              class="remove-image-button"
              (click)="removeSelectedImage()">

              Remover imagem
            </button>
          </div>
        </div>

        <div
          class="edit-image-hint full-field"
          *ngIf="editingProductId">

          <span>📷</span>

          <div>
            <strong>Quer trocar a foto?</strong>
            <small>
              Salve as alterações e use o botão “Trocar foto”
              no card do produto.
            </small>
          </div>
        </div>

      </div>

      <div class="form-actions">

        <button
          *ngIf="editingProductId"
          type="button"
          class="secondary-button cancel-edit-button"
          [disabled]="savingProduct"
          (click)="cancelProductEdit()">

          Cancelar edição
        </button>

        <button
          type="button"
          class="primary-button save-product-button"
          [disabled]="savingProduct"
          (click)="saveProduct()">

          {{
            savingProduct
              ? 'Salvando...'
              : editingProductId
                ? 'Salvar alterações'
                : 'Salvar produto'
          }}
        </button>

      </div>
    </section>

  </div>

  <!-- Lista de produtos -->

  <section
    class="products-section"
    *ngIf="restaurantId">

    <header class="products-header">
      <div>
        <span class="section-label">Produtos cadastrados</span>
        <h2>Cardápio atual</h2>

        <p>
          {{ products.length }} produto(s) encontrado(s)
        </p>
      </div>
    </header>

    <div
      class="loading-state"
      *ngIf="loadingProducts">

      Carregando produtos...
    </div>

    <div
      class="empty-state"
      *ngIf="!loadingProducts && !products.length">

      <div class="empty-icon">🍽️</div>
      <h3>Nenhum produto cadastrado</h3>
      <p>
        Cadastre o primeiro produto usando o formulário acima.
      </p>
    </div>

    <div class="products-grid">

      <article
        class="product-card"
        *ngFor="
          let product of products;
          trackBy: trackByProductId
        "
        [class.inactive]="!product.isActive">

        <div class="product-image-area">

          <img
            class="product-image"
            *ngIf="product.imageUrl"
            [src]="getImageUrl(product.imageUrl)"
            [alt]="product.name">

          <div
            class="product-image no-image"
            *ngIf="!product.imageUrl">

            <span>📷</span>
            <small>Sem imagem</small>
          </div>

          <span
            class="product-status"
            [class.status-inactive]="!product.isActive">

            {{ product.isActive ? 'Ativo' : 'Inativo' }}
          </span>

          <label class="change-image-button">
            {{
              changingImageProductId === product.id
                ? 'Enviando...'
                : 'Trocar foto'
            }}

            <input
              type="file"
              accept="image/*"
              hidden
              [disabled]="changingImageProductId === product.id"
              (change)="changeProductImage($event, product)">
          </label>

        </div>

        <div class="product-content">

          <div class="product-category">
            {{ product.category?.name || 'Sem categoria' }}
          </div>

          <h3>{{ product.name }}</h3>

          <p class="product-description">
            {{
              product.description ||
              'Nenhuma descrição cadastrada.'
            }}
          </p>

          <div class="product-footer">

            <strong class="product-price">
              {{ formatMoney(product.price) }}
            </strong>

            <div class="product-actions">

              <button
                type="button"
                class="product-action edit-product"
                [disabled]="
                  savingProduct ||
                  deletingProductId === product.id
                "
                (click)="editProduct(product)">

                ✏️ Editar
              </button>

              <button
                type="button"
                class="product-action status-button"
                [class.deactivate-button]="product.isActive"
                [class.activate-button]="!product.isActive"
                [disabled]="
                  changingStatusProductId === product.id ||
                  deletingProductId === product.id
                "
                (click)="toggle(product)">

                {{
                  changingStatusProductId === product.id
                    ? 'Alterando...'
                    : product.isActive
                      ? 'Inativar'
                      : 'Ativar'
                }}
              </button>

              <button
                type="button"
                class="product-action delete-product"
                [disabled]="
                  deletingProductId === product.id ||
                  changingStatusProductId === product.id
                "
                (click)="deleteProduct(product)">

                {{
                  deletingProductId === product.id
                    ? 'Excluindo...'
                    : '🗑️ Excluir'
                }}
              </button>

            </div>

          </div>

        </div>

      </article>

    </div>

  </section>

</section>